import React from "react";
import { Modal } from "react-bootstrap";
import { DELETE_ATTRACTION } from "../../mutation/DeleteAttraction";
import { useMutation } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";
import { useHistory } from "react-router-dom";

const DeleteAttraction = (props) => {
  const [DeleteAttractionId] = useMutation(DELETE_ATTRACTION, {
    client: hasuraClient,
  });
  const history = useHistory();

  return (
    <Modal
      className="delete-popup"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Are you sure you want to delete this attraction?</h4>
        <div className="button-row">
          <button className="cancel-btn" onClick={props.onHide}>
            Cancel
          </button>
          <div
            className="button"
            style={{ cursor: "pointer" }}
            onClick={() => {
              DeleteAttractionId({
                variables: {
                  id: props.id,
                },
              })
                .then(() => {
                  if (props.isDetails) {
                    history.push("/attractions");
                  } else {
                    props.refetch();
                  }
                  props.onHide();
                })
                .catch(() => {
                  props.onHide();
                });
            }}
          >
            Yes
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Header closeButton></Modal.Header> */}
      {/* <Modal.Body>
        <div className="success-body">
          <h2>Are you sure you want to delete this attraction?</h2>

          <div className="button-row">
            <div className="cancel-btn">
              <button onClick={props.onHide} className="secondary-button">
                Cancel
              </button>
            </div>
            <div className="col">
              <button
                className="button"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  DeleteAttractionId({
                    variables: {
                      id: props.id,
                    },
                  })
                    .then((response) => {
                      props.refetch();
                      props.onHide();
                    })
                    .catch((e) => {
                      const errors = e.graphQLErrors;
                      props.onHide();
                    });
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </Modal.Body> */}
    </Modal>
  );
};

export default DeleteAttraction;
